// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';
import type { PostCalltaskBatchReTranslateBody, BaseResponseVoid } from '../../../types';

/**
 * 批量重新翻译
 *
 * @export
 * @tags data-call-manual-add-qa-task-controller
 * @link [POST] /calltask/batch/reTranslate
 */
export function postCalltaskBatchReTranslate(
    data: PostCalltaskBatchReTranslateBody
): Promise<BaseResponseVoid>;
export function postCalltaskBatchReTranslate(
    data: PostCalltaskBatchReTranslateBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseVoid>;
export function postCalltaskBatchReTranslate(
    data: PostCalltaskBatchReTranslateBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseVoid> {
    return request<PostCalltaskBatchReTranslateBody, never, never>('/calltask/batch/reTranslate', {
        ...options,
        data,
        method: 'post',
        __$requestCalleeName: 'postCalltaskBatchReTranslate',
    });
}

export const meta = [
    {
        tags: ['data-call-manual-add-qa-task-controller'],
        path: '/calltask/batch/reTranslate',
        method: 'post',
    },
];
